import { BoldIcon, ItalicIcon, UnderlineIcon, styled, css, ModeProvider } from 'canoe';
import React, { useMemo } from 'react';
import { Editor } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';

import { Separator } from 'craft/components/SelectedToolbar/Separator';

import { FormatButton } from './FormatButton';
import { LinkButton } from './LinkButton';
import { TextAlignmentButtons } from './TextAlignmentButtons';
import { VariableButton } from './VariableButton/VariableButton';
import { VariantSelector } from './VariantSelector';

const ToolbarMenuBodyContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.OnyxGrayD10};
    border-radius: 0.25em;
    display: flex;
    line-height: 21px;
    white-space: nowrap;
    align-items: center;
    button {
      align-self: center;
      margin: ${theme.spaces.xxs};
    }
  `}
`;

export const Toolbar = () => {
  const rteEditor = useSlate() as ReactEditor;

  const isEditable = useMemo(() => {
    try {
      if (!rteEditor.selection) {
        return false;
      }
      const [selectedNode] = Editor.node(rteEditor, rteEditor.selection);
      const toDomNode = ReactEditor.toDOMNode(rteEditor, selectedNode);
      return ReactEditor.hasDOMNode(rteEditor, toDomNode, { editable: true });
    } catch (e) {
      return false;
    }
  }, [rteEditor.selection]);

  if (!rteEditor.selection) {
    return null;
  }

  return (
    <ModeProvider value={{ mode: 'Dark' }}>
      <ToolbarMenuBodyContainer>
        <FormatButton
          disabled={!isEditable}
          format="bold"
          tooltip="Bold"
          shortcuts={['mod', 'B']}
          icon={BoldIcon}
        />
        <FormatButton
          disabled={!isEditable}
          format="italic"
          tooltip="Italic"
          shortcuts={['mod', 'I']}
          icon={ItalicIcon}
        />
        <FormatButton
          disabled={!isEditable}
          format="underline"
          tooltip="Underline"
          shortcuts={['mod', 'U']}
          icon={UnderlineIcon}
        />
        <Separator />
        <LinkButton disabled={!isEditable} />
        <VariableButton disabled={!isEditable} />
        <TextAlignmentButtons disabled={!isEditable} />
        <VariantSelector />
      </ToolbarMenuBodyContainer>
    </ModeProvider>
  );
};
